export type MetricKey =
  | 'planned'
  | 'executed'
  | 'incidents'
  | 'incidentPct'
  | 'pending'
  | 'compliance'
  | 'material'
  | 'routes'
  | 'days'
  | 'avgStart'
  | 'avgEnd'
  | 'duration'
  | 'vph';

/**
 * The metric columns, in display order, with their title key and width. The
 * column definitions AND the total-row cells are both built from this one
 * list, so they cannot drift apart.
 */
export const METRIC_COLUMNS: {
  key: MetricKey;
  titleKey: string;
  width: number;
}[] = [
  { key: 'compliance', titleKey: 'compliance', width: 140 },
  { key: 'planned', titleKey: 'planned', width: 80 },
  { key: 'executed', titleKey: 'executed', width: 80 },
  { key: 'incidents', titleKey: 'incidents', width: 80 },
  { key: 'incidentPct', titleKey: 'incident_pct', width: 88 },
  { key: 'pending', titleKey: 'pending', width: 80 },
  { key: 'material', titleKey: 'material', width: 96 },
  { key: 'routes', titleKey: 'routes', width: 76 },
  { key: 'days', titleKey: 'days', width: 72 },
  { key: 'avgStart', titleKey: 'avg_start', width: 104 },
  { key: 'avgEnd', titleKey: 'avg_end', width: 112 },
  { key: 'duration', titleKey: 'avg_duration', width: 120 },
  { key: 'vph', titleKey: 'visits_per_hour', width: 100 },
];

/** Fixed leading columns: the van (frozen) and its zones. */
export const NAME_COLUMN_WIDTH = 200;
export const ZONES_COLUMN_WIDTH = 160;

/**
 * Position of a metric column, for the total row. A key that is not among the
 * columns would silently shift every cell after it: fail loudly instead.
 */
export const columnIndexOf = (columnKeys: string[], key: MetricKey): number => {
  const index = columnKeys.indexOf(key);
  if (index < 0) {
    throw new Error(`Vans table: no column for metric "${key}"`);
  }

  return index;
};
